/* **** MDL FULL SIZE SLIDER   ***** */
const addSlidesToSlickSlider = () => {
  if (
    $('.mdl-slider').length &&
    $('.mdl-slider').find('.mdl-slider__item').length == 0
  ) {
    $('.js-img-to-slider').each(function () {
      $(this).css('cursor', 'pointer');
      let src = $(this).attr('src'),
        $slide = $(
          `
                  <div class="mdl-slider__item">
                      <figure class="mdl-slider__media">
                          <div class="mdl-slider__media-content">
                            <img
                              class="mdl-slider__img"
                              src="` +
            src +
            `"
                              alt=""
                            />
                          </div>
                      </figure>
                  </div>
                `
        );
      $slide.appendTo('.mdl-slider');
    });
  }
};

$(document).ready(function () {
  addSlidesToSlickSlider();

  if ($('.mdl-slider').length) {
    var $status = $('.mdl__slider-dots');
    var $slickElement = $('.mdl-slider');

    $slickElement.on(
      'init reInit afterChange',
      function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.html(
          `<li class="mdl__slider-dot">` +
            i +
            `</li><li class="mdl__slider-dot">&nbsp;of&nbsp;</li>` +
            `<li class="mdl__slider-dot">` +
            slick.slideCount +
            `</li>`
        );
      }
    );

    var mdlOptions = {
      arrows: true,
      dots: false,
      //common options
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: false,
      infinite: true,
      draggable: true,
      swipe: true,
      touchMove: true,
      adaptiveHeight: true,
    };
    $('.mdl-slider').slick(mdlOptions);
  }
});

$(document).on('click', '.js-img-to-slider', function () {
  $('.js-img-to-slider').each(function (i) {
    $(this).attr('data-index', i);
  });
  var index = $(this).attr('data-index');

  $('.mdl-slider').slick('slickGoTo', index);
  $('.mdl-slider').slick('refresh');
});
